import * as am5 from '@amcharts/amcharts5';
import {
  Bullet,
  Circle,
  IBulletSettings,
  ICircleSettings,
  ITooltipSettings,
  Root,
  Tooltip,
} from '@amcharts/amcharts5';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import {
  AxisRendererX,
  AxisRendererY,
  IAxisRendererXSettings,
  IAxisRendererYSettings,
  ICategoryAxisSettings,
  IColumnSeriesSettings,
  IDateAxisSettings,
  ILineSeriesSettings,
  IValueAxisSettings,
  IXYChartSettings,
  IXYCursorSettings,
  XYCursor,
} from '@amcharts/amcharts5/xy';
import * as am5xy from '@amcharts/amcharts5/xy';

import { AM_CHARTS_V5_LICENSE } from 'utils/environmentVariables';

export const am5Root = (chartId: string) => {
  const root = am5.Root.new(chartId);
  root.setThemes([am5themes_Animated.new(root)]);
  am5.addLicense(AM_CHARTS_V5_LICENSE);
  return root;
};

export const am5XYChart = (root: am5.Root, settings: IXYChartSettings) =>
  am5xy.XYChart.new(root, settings);

export const dateAxis = (root: am5.Root, settings: IDateAxisSettings<any>) =>
  am5xy.DateAxis.new(root, settings);

export const valueAxis = (root: Root, settings: IValueAxisSettings<any>) =>
  am5xy.ValueAxis.new(root, settings);

export const categoryAxis = (root: Root, settings: ICategoryAxisSettings<any>) =>
  am5xy.CategoryAxis.new(root, settings);

export const lineSeries = (root: Root, settings: ILineSeriesSettings) =>
  am5xy.LineSeries.new(root, settings);

export const columnSeries = (root: Root, settings: IColumnSeriesSettings) =>
  am5xy.ColumnSeries.new(root, settings);

export const cursor = (root: Root, settings: IXYCursorSettings) => XYCursor.new(root, settings);

export const xAxisRenderer = (root: Root, settings: IAxisRendererXSettings) =>
  AxisRendererX.new(root, settings);

export const yAxisRenderer = (root: Root, settings: IAxisRendererYSettings) =>
  AxisRendererY.new(root, settings);

export const toolTip = (root: Root, settings: ITooltipSettings) => Tooltip.new(root, settings);

export const bullet = (root: Root, settings: IBulletSettings) => Bullet.new(root, settings);

export const circle = (root: Root, settings: ICircleSettings) => Circle.new(root, settings);
